module.exports = __webpack_public_path__ + "static/img/eat-type-item-03.a56d7dbf.png";